import { TYPES, MODES, PATHS } from '../utils';
import { getCategoryPath } from './items/category';
import { getStorePath } from './items/store';
import { getSubCategoryPath } from './items/sub_category';
import { getNestedSubCategoryPath } from './items/nested_sub_category';
import { getStaticPagePath } from './items/filtered_page';
import { getSearchQueryPath } from './items/search_query';
import { getLogoMakerIdeasPath } from './items/logo_maker';
import { getContentPagePath } from './items/content_page';
import { getLandingPagePath } from './items/landing_page';

const formatStyle = (style) => style && style.toLowerCase().replace(/ /g, '-');

const getDisplayName = (type, urlParams, locale) => {
    const displayNameTransformer = displayName[type];

    if (!displayNameTransformer || !displayNameTransformer(urlParams)){
        return '';
    }

    return i18n.t(displayNameTransformer(urlParams), { $scope: locale });
};

export const displayName = {
    [TYPES.CATEGORY]: ({ id }) => `categories.category_${id}.name`,
    [TYPES.SUB_CATEGORY]: ({ id }) => `sub_categories.sub_category_${id}.name`,
    [TYPES.NESTED_SUB_CATEGORY]: ({ id, subCategoryId }) => `sub_categories.sub_category_${subCategoryId}.nested_sub_cat_${id}.name`,
    [TYPES.STORE]: () => '',
    [TYPES.FILTERED_PAGE]: ({ id }) => `sub_categories.sub_category_${id}.name`,
    [TYPES.SEARCH_QUERY]: () => ''
};

export const urlBuilder = {
    [TYPES.CATEGORY]: ({ id, queryParams, source }, locale, mode) => getCategoryPath({ id, queryParams, source, mode }, locale),
    [TYPES.PRO_CATEGORY]: ({ id, queryParams, source }, locale) => getCategoryPath({ id, queryParams, source, mode: MODES.PRO }, locale),
    [TYPES.SUB_CATEGORY]: ({ id, categoryId, queryParams, source }, locale, mode) => getSubCategoryPath({ categoryId, id, queryParams, mode, source }, locale),
    [TYPES.PRO_SUB_CATEGORY]: ({ id, categoryId, queryParams, source }, locale) => getSubCategoryPath({ categoryId, id, queryParams, source, mode: MODES.PRO }, locale),
    [TYPES.NESTED_SUB_CATEGORY]: ({ categoryId, id, subCategoryId, queryParams, source }, locale) => getNestedSubCategoryPath({ categoryId, id: subCategoryId, nestedSubCategoryId: id, queryParams, source }, locale),
    [TYPES.STORE]: ({ slug, queryParams, source }) => getStorePath({ slug, queryParams, source }),
    [TYPES.FILTERED_SUB_CATEGORY]: ({ categoryId, id, nestedSubCategoryId, filterUid, queryParams }, locale) => getStaticPagePath({ categoryId, id, nestedSubCategoryId, filterId: filterUid, queryParams }, locale),
    [TYPES.SEARCH_QUERY]: ({ query, id, queryParams, source }) => getSearchQueryPath({ query, id, queryParams, source }),
    [TYPES.PRO_SEARCH_QUERY]: ({ query, queryParams, source }) => getSearchQueryPath({ query, queryParams, source, mode: MODES.PRO }),
    [TYPES.LOGO_MAKER_IDEAS]: ({ tag, tagType }) => getLogoMakerIdeasPath({ tag, tagType }),
    [TYPES.CONTENT_PAGE]: ({ slug, source }) => getContentPagePath({ slug, source }),
    [TYPES.LANDING_PAGE]: ({ slug }) => getLandingPagePath({ slug }),
    [TYPES.LINK_URL]: ({ url }) => url
};

export const configuredMenuItemTransformer = ({ type, urlParams, alias, designStyle, ...rest }, locale, mode) => ({
    ...rest,
    style: formatStyle(designStyle),
    type,
    url: urlBuilder[type] ? urlBuilder[type]({ ...urlParams }, locale, mode) : PATHS.ROOT,
    displayName: alias || getDisplayName(type, urlParams, locale),
    reportData: {
        ...urlParams && { categoryId: urlParams.categoryId || urlParams.id }
    }
});
